import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TUserCard, TUserCardResponse, adaptUserCardFromResponse } from '../../types';
import { BACKEND_ADMIN_USERS_CARDS } from '../../backend-paths';


export const userCardReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_USERS_CARDS}/:nickname`,
	(payload: string, thunkApi) => {
		const path = `${BACKEND_ADMIN_USERS_CARDS}/${payload}`;

		return HttpService.get<TUserCardResponse>(path).then(result => {
			return adaptUserCardFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUserCard> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userCardReadSlice = createSlice({
	name: 'userCardReadSlice',
	initialState,
	reducers: {
		setUserCardRead(state, action: PayloadAction<TUserCard>) {
			state.item = action.payload;
		},

		clearUserCardRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userCardReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userCardReadGetApi.fulfilled.type]: (state, action: PayloadAction<TUserCard>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userCardReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserCardReadSelector = () => useAppSelector(state => state[userCardReadSlice.name]);

export const { clearUserCardRead, setUserCardRead } = userCardReadSlice.actions;
